var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcsmlogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 470.002,
    height: 143,
    viewBox: "0 0 470.002 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777",
    transform: "translate(-2010.854 -1127.349)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "DATA_HUB",
    "data-name": "DATA HUB",
    transform: "translate(2010.854 1256.349)",
    fill: "#011b60",
    fontSize: 30,
    fontFamily: "Avenir-Regular, Avenir",
    letterSpacing: "0.3em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DATA HUB")), /*#__PURE__*/React.createElement("text", {
    id: "acsm",
    transform: "translate(2010.854 1223.349)",
    fill: "#0a5fff",
    fontSize: 89,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "acsm")), /*#__PURE__*/React.createElement("text", {
    id: "Advocacy_Communication_and_Social_Mobilization",
    "data-name": "Advocacy Communication  and Social Mobilization",
    transform: "translate(2238.855 1200.85)",
    fill: "#02105f",
    fontSize: 20,
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Advocacy Communication "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 25
  }, "and Social Mobilization")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcsmlogo1);
export default __webpack_public_path__ + "static/media/acsmlogo1.6f461de241300faf3c2b3460b822b9ef.svg";
export { ForwardRef as ReactComponent };